import { HealthThemes } from '../modules/records/index.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';

export function CompanyHealthThemesScreen() {
  const { can, timeZone } = useCompanyScope();
  return (
    <GatedCompanyScreen allowed={can('records.templates.manage')}>
      <HealthThemes timeZone={timeZone} />
    </GatedCompanyScreen>
  );
}
